<template>
	<div>
		我的服务
	</div>
</template>
<script>
	export default {
		components: {},
		data() {
			return {
				formData: {}
			}
		},
		methods: {},
		mounted() {}
	};
</script>
<style lang='scss' scoped>
</style>
